export var TestSessionBannerDataHooks = {
    ROOT: 'test-session-banner',
};
//# sourceMappingURL=TestSessionBannerDataHooks.js.map